/**
 * Enum mapping utilities for converting UI state to API enum values
 */

// PreOrderType enum mapping
export var PRE_ORDER_TYPE_MAPPING = {
  pickup: 'PICKUP',
  delivery: 'DELIVERY',
  curbsidePickup: 'CURBSIDE',
  driveThruPickup: 'DRIVE_THRU',
  inStorePickup: 'PICKUP' // Maps to same as pickup
};

// PlatformType enum mapping based on UI variant
export var PLATFORM_TYPE_MAPPING = {
  'mobile-ecomm': 'MOBILE',
  kiosk: 'KIOSK',
  "default": 'ONLINE_MENU',
  embedded: 'ONLINE_MENU',
  'store-front': 'ONLINE_MENU',
  plus: 'ONLINE_MENU',
  messaging: 'ONLINE_MENU'
};

/**
 * Maps order type string to PreOrderType enum value
 * @param {string} orderType - The order type (pickup, delivery, curbsidePickup, etc.)
 * @returns {string|null} - The corresponding PreOrderType enum value or null
 */
export function mapOrderTypeToPreOrderType(orderType) {
  if (!orderType) {
    return null;
  }
  return PRE_ORDER_TYPE_MAPPING[orderType] || null;
}

/**
 * Maps UI variant to PlatformType enum value
 * @param {string} variant - The UI variant (mobile-ecomm, kiosk, default, etc.)
 * @returns {string|null} - The corresponding PlatformType enum value or null
 */
export function mapVariantToPlatformType(variant) {
  if (!variant) {
    return null;
  }
  return PLATFORM_TYPE_MAPPING[variant] || 'ONLINE_MENU';
}

/**
 * Determines PlatformType based on UI state flags
 * @param {Object} UI - The UI store object
 * @returns {string|null} - The corresponding PlatformType enum value or null
 */
export function determinePlatformType(UI) {
  if (!UI) {
    return null;
  }

  // Check for mobile ecomm app first
  if (UI.isMobileEcommApp) {
    return 'MOBILE';
  }

  // Check for kiosk
  if (UI.isKiosk) {
    return 'KIOSK';
  }

  // Default to online menu for all other variants
  return 'ONLINE_MENU';
}